import NoticeModularService from '../notice-modular-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { purchaseProjectStatus } from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  mixins: [purchaseProjectStatus],
  data () {
    return {
      tabList: [], // tab集合
      tabActiveType: 1,
      total: 0,
      tableList: [],
      projectStatusArr: [],
      tabList2: [
        {
          name: '交易项目',
          value: '0',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        },
        {
          name: '集中交易项目',
          value: '1',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        }
      ],
      activeName: '0',
      searchForm: {
        projectType: 1, // 1转让 2采购
        pageNum: 1,
        pageSize: 10
        // city: '2203'
      }
    };
  },
  created () {
    // 获取tab按钮字典
    const arr = [
      ['PROJECT_CATEGORY']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value).then(res => {
        if (res && res.code === '0') {
          this.tabList = res.data;
        }
      });
      Service.getSelectList('BACTH_PROJECT_TYPE').then(res => {
        if (res && res.code === '0') {
          this.projectStatusArr = res.data;
        }
      });
    });
    this.getSignUpRecordList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    changeTabIndex (type) {
      this.tabActiveType = type;
      this.searchForm.projectType = type;
      this.activeName = '0';
      this.getSignUpRecordList();
    },
    handleClick () {
      // console.log(this.activeName);
      if (this.activeName === '1') {
        this.getCentralizedTradingList();
      } else {
        this.getSignUpRecordList();
      }
    },
    getCentralizedTradingList (page) {
      this.tableList = [];
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      }
      NoticeModularService.getCentralizedTradingList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.tableList = res.data.list;
          this.total = res.data.total;
          this.tableList.forEach(item => {
            // 公示日期转化
            item.transactionAnnouncementTime = this.$options.filters['baseDate'](item.transactionAnnouncementTime);
          });
        }
      });
    },
    // 获取交易公示列表
    getSignUpRecordList (page) {
      this.tableList = [];
      if (page) {
        this.searchForm.projectType = this.searchForm.projectType;
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      }
      NoticeModularService.getFormulaProjectList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          // this.tableList = res.data.list;
          this.total = res.data.total;

          // 临时 TODO
          // let addItem = [{
          //   'bidId': 999999999,
          //   'currentPrice': 630000,
          //   'price': null,
          //   'projectCode': '0221201-210099J',
          //   'projectId': 999999999,
          //   'projectName': '吉林市永吉县黄榆乡头道川村二社荒地',
          //   'transactionAnnouncementTime': '2021-05-19T07:54:44.000+0000',
          //   'userId': null,
          //   'tradeType': 2
          // }];
          // 交易项目
          if (Number(this.searchForm.projectType) === 1) {
            this.tableList = [...res.data.list];
          } else {
            // console.log(res.data.list);
            this.tableList = res.data.list;
            // this.tableList = res.data.list.filter(item => item.projectCode === '0322106-210492C');
            // this.tableList.unshift();
          }
          // this.tableList = [...addItem, ...res.data.list];
          this.tableList.forEach(item => {
            // 公示日期转化
            item.transactionAnnouncementTime = this.$options.filters['baseDate'](item.transactionAnnouncementTime);
          });
          // console.log(this.tableList);
        }
      });
    },
    clear () {
      this.searchForm = {
        projectType: '',
        pageNum: 1,
        pageSize: 5
      };
      this.getSignUpRecordList();
    },
    handdle (row, event, column) {
      console.log(row, event, column);
      if (this.activeName === '1') {
        this.$router.push('/notice-modular/BatchDetail?id=' + row.id + '&time=' + row.createTime);
      } else {
        this.$router.push('/notice-modular/detail?id=' + row.bidId + '&time=' + row.transactionAnnouncementTime + '&type=' + this.tabActiveType);
      }

    }
  }
};
